<template src="./template.html"></template>

<script>
    import axios from 'axios';
    import { mapGetters } from 'vuex';
    import PageHeading from '../../modules/03_page_heading';
    import Select from '../../cmp/select';

    export default {
        name: 'home',
        props: ['step'],
        components: { PageHeading, Select },
        computed: {
            ...mapGetters(['get_wording', 'get_buildings', 'get_building_by_id', 'get_selected_building_slug', 'get_selection', 'get_order_created', 'get_loader']),
            buildingsList() {
                return this.get_buildings.map((building) => {
                    let buildingForSelect = {};
                    buildingForSelect.value = building.id;
                    buildingForSelect.name = building.address;
                    return buildingForSelect;
                })
            },
            buildingImage() {
                const activeBuilding = this.get_building_by_id(this.get_selection.activeBuilding);
                return this.$resourcesUrl + activeBuilding.image;
            },
        },
        beforeMount () {
            this.$store.dispatch('UPDATE_STEPS', this.$props.step);
        },
        created () {
            if (this.get_order_created) {
                this.$store.dispatch('RESET_STATE');
            }

            if (this.$route.name === 'Home') {
                // Redirect to first building
                if (this.get_buildings.length === 0) {
                    this.fetchBuildings().then((buildings) => {
                        if (this.get_buildings.length > 0){
                            this.chooseBuilding(buildings[0].id)
                        }
                    });
                } else {
                    this.chooseBuilding(this.get_buildings[0].id);
                }
            } else if (this.$route.name === 'Buildings') {
                // Show buildings overview
                if (this.get_buildings.length === 0) {
                    this.fetchBuildings().then((buildings) => {
                        this.$store.dispatch('SET_ACTIVE_BUILDING', buildings[0].id);
                    })
                }
            }

        },
        methods: {
            fetchBuildings() {
                this.$store.dispatch('SET_LOADER', true);
                return axios.get(`${this.$apiUrl}/building/list`)
                    .then((response) => {
                        this.$store.dispatch('SET_LOADER', false);
                        this.$store.dispatch('SET_BUILDINGS', response.data.data);

                        return response.data.data;
                    })
                    .catch(function (error) {
                    });
            },
            chooseBuilding(id) {
                this.$store.dispatch('SET_ACTIVE_BUILDING', id);
                this.$router.push(`/${this.get_selected_building_slug}`);
            },
            selectChange(buildingId) {
                this.$store.dispatch('SET_ACTIVE_BUILDING', buildingId);
            }
    }
    };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/00_home/index.vue